(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ovrze-product-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ovrze-offer')) {
 customElements.define('ovrze-offer', class extends HTMLElement {
  connectedCallback() {
   if (this.bound) return;
   this.bound = true;
   this.querySelector('[data-copy-code]').addEventListener('click', async () => {
    const code = this.querySelector('[data-discount-code]');
    const status = this.querySelector('[role="status"]');
    try {
     await navigator.clipboard.writeText(code.textContent.trim());
     status.textContent = this.dataset.success;
    } catch {
     const range = document.createRange();
     range.selectNodeContents(code);
     const selection = window.getSelection();
     selection.removeAllRanges(); selection.addRange(range);
     status.textContent = this.dataset.failure;
    }
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ovrze-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ovrze-size-guide')) {
 customElements.define('ovrze-size-guide', class extends HTMLElement {
  connectedCallback() {
   if (this.bound) return;
   this.bound = true;
   const source = this.querySelector('template');
   const tables = source.content.querySelectorAll('table');
   const dialog = this.querySelector('dialog');
   if (!tables.length || typeof dialog.showModal !== 'function') return;
   const opener = this.querySelector('[data-open-guide]');
   const content = this.querySelector('[data-size-content]');
   tables.forEach(table => content.append(table.cloneNode(true)));
   this.querySelector('[data-guide-fallback]').hidden = true;
   opener.hidden = false;
   opener.addEventListener('click', () => dialog.showModal());
   this.querySelector('[data-close-guide]').addEventListener('click', () => dialog.close());
   dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
   });
   dialog.addEventListener('close', () => opener.focus());
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
